<template>
  <div>

    <el-row :gutter="5">
      <el-form ref="params" :model="params">
        <el-col :span="2" :xs="12">
          <el-form-item prop="id">
            <el-input v-model.number="params.id" type="number" placeholder="ID"/>
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="socketNum">
            <el-input v-model="params.nickName" placeholder="昵称"/>
          </el-form-item>
        </el-col>
        <el-col :span="3" :xs="12">
          <el-form-item prop="phone">
            <el-input v-model.number="params.phone" maxlength="11" placeholder="手机号"/>
          </el-form-item>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button type="primary" @click="search">搜索</el-button>
        </el-col>
        <el-col :span="2" :xs="12">
          <el-button plain type="success" @click="reset">清空搜索</el-button>
        </el-col>
      </el-form>
    </el-row>

    <el-table v-loading="loadTable" :data="records" stripe>
      <el-table-column fixed label="ID" prop="id">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.id }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="昵称" prop="nickName">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.nickName?scope.row.nickName:'未填写' }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="头像" prop="headImage">
        <template slot-scope="scope">
          <div class="demo-image__preview">
            <el-image
                style="width: 100px; height: 100px"
                :src="fileBaseUrl+scope.row.headImage"
                :preview-src-list="[fileBaseUrl+scope.row.headImage]">
            </el-image>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="手机号" prop="phone">
        <template slot-scope="scope">
                    <span>
                       {{ scope.row.phone?scope.row.phone:'未绑定' }}
                    </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="300" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="mini" @click="onShowApplyMerchant(scope.row)">合伙人入驻</el-button>
        </template>
      </el-table-column>
    </el-table>
    <page :current="current" :size="size" :total="total"/>

    <el-dialog
        title="合伙人入驻"
        :visible.sync="showApplyMerchant"
        width="30%"
        center>
      <el-button type="primary" @click="uploadImg">上传资质<i class="el-icon-upload el-icon--right"></i></el-button>
      <div v-for="(e,i) in applyMerchant.imgs" :key="i">
        <img :src="e" width="100px" height="100px">
        <el-button v-if="i!==0" type="info" size="mini" icon="el-icon-top" circle @click="moveResource(i, true)"></el-button>
        <el-button v-if="i!==applyMerchant.imgs.length-1" type="info" size="mini" icon="el-icon-bottom" circle @click="moveResource(i, false)"></el-button>
        <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="onShowDelImg(i)"></el-button>
      </div>
      <input
          type="file"
          accept="image/*"
          name="file"
          ref="uploadImg"
          id="uploadImg"
          @change="changeImg"
          style="opacity: 0; width: 0; height: 0; cursor: pointer"
      />

      <el-form :model="applyMerchant" label-width="150px" ref="ApplyMerchantForm">
        <el-form-item label="店铺名" prop="store"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              clearable
              placeholder="请输入店铺名"
              maxlength="50"
              v-model="applyMerchant.store">
          </el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              clearable
              placeholder="请填写店铺电话"
              maxlength="11"
              v-model="applyMerchant.phone">
          </el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              clearable
              placeholder="昵称可作为登录账号"
              maxlength="50"
              v-model="applyMerchant.nickname">
          </el-input>
        </el-form-item>
        <el-form-item label="地区" prop="areaDetailId"
                      :rules="[
                      { required: true, message: '请选择地区'},
                      ]">
          <el-cascader
              v-model="applyMerchant.areaDetailId"
              :options="areaDetails"
              :props="{ expandTrigger: 'hover' }"
              filterable
              clearable
          ></el-cascader>
        </el-form-item>
        <el-form-item label="详细地址" prop="address"
                      :rules="[
                      { required: true, message: '不能为空'},
                      ]">
          <el-input
              clearable
              placeholder="请填写详细地址"
              maxlength="50"
              v-model="applyMerchant.address">
          </el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
              clearable
              placeholder="请填写备注"
              maxlength="50"
              v-model="applyMerchant.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button v-if="applyMerchant.state!=='2'" type="primary" size="small" icon="el-icon-check" @click="doApplyMerchant('ApplyMerchantForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 删除资源 -->
    <el-dialog
        title="提示"
        :visible.sync="showDelImg"
        width="30%"
        center>
      <div style="align-content: center">您确认要删除吗？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDelImg = false">取 消</el-button>
        <el-button type="primary" @click="doDelCardResource">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>

import page from "@/api/user/we-chat-user-manage/page";
import Page from "@/components/Page.vue";
import getAliyunOssSign from "@/api/common/getAliyunOssSign";
import Axios from "axios";
import {Message} from "element-ui";
import {generateUUID} from "@/utils/UUIDUtils";
import listAreas from "@/api/area/list";
import {formatAgencyAreaDetails} from "@/utils/areaDetails";
import getMerchantByWeChatMPId from "@/api/MyWeChatMPUser/getMerchantByWeChatMPId";
import applyMerchant from "@/api/MyWeChatMPUser/applyMerchant";
import adminGetFileSignUrl from "@/api/common/adminGetFileSignUrl";

export default {
  name: "MyWeChatMPUserManage",
  components: {Page},
  data() {
    return {
      fileBaseUrl: process.env.VUE_APP_FILE_BASE_URL,
      current:1,
      size:10,
      total: 0,

      params: {},

      loadTable: false,
      records: [],

      areaDetails:[],

      showApplyMerchant:false,
      applyMerchant:{
        wechatMpId:undefined,
        store:undefined,
        phone:undefined,
        nickname:undefined,
        areaDetailId:[],
        areaId:undefined,
        address:undefined,
        remark:undefined,
        state:undefined,
        reply:undefined,
        imgs:[],
      },
      showDelImg:false,
      delImgIndex:undefined,

    }
  },

  methods: {
    doApplyMerchant(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const params = JSON.parse(JSON.stringify(this.applyMerchant))
          params.areaId = params.areaDetailId[params.areaDetailId.length-1]
          params.areaDetailId = undefined
          //处理图片数据
          const imgs = params.imgs
          const u1 = this.fileBaseUrl+'/upload/temp/'
          //需要上传的图片
          const uploadImgs = []
          //需要保留的图片
          const saveImgs = []
          for(let i=0;i<imgs.length;i++){
            let url = imgs[i]
            const u2 = url.substring(0,u1.length)
            let path = url.split('?')[0].substring(this.fileBaseUrl.length)
            if(u1===u2){
              uploadImgs.push(path)
            }else{
              saveImgs.push(path)
            }
          }
          params.uploadImgs = uploadImgs
          params.saveImgs = saveImgs
          applyMerchant(params.wechatMpId,params).then(res=>{
            if (res.code === 1){
              Message({message: '成功', type:'success', duration: 3000})
              this.showApplyMerchant=false
            }else{
              if (res.data && res.data.illError){
                Message({message: res.data.illError, type: 'error', duration: 3000})
              }else{
                Message({message: '失败', type: 'error', duration: 3000})
              }
            }
          })
        } else {
          console.error('error submit!!');
          return false;
        }
      });
    },
    changeImg(file){
      getAliyunOssSign("/common/sign").then(response=>{
        //设置相关的参数
        let resultObj = response.data;
        //上传的文件名，使用UUID处理一下
        let pre = resultObj.dir + '/'+generateUUID()+'_'
        file = file.target.files[0];
        let data = new FormData();
        data.append("key", pre+'${filename}')
        data.append("OSSAccessKeyId", resultObj.accessid)
        data.append("policy", resultObj.policy)
        data.append("signature", resultObj.signature)
        data.append("file", file)
        data.append("success_action_status", 200)

        let config = {
          'Content-Type': 'multipart/form-data'
        }
        Axios.post(resultObj.host, data, config).then((res)=>{
          if(res.status==200){
            let filepath = pre+file.name
            adminGetFileSignUrl(filepath).then(temp=>{
              this.applyMerchant.imgs.push(temp.data)
              Message({
                message:"成功",
                type:"success",
                duration:3000
              })
            })
          }
        }).catch(err=>{
          console.error(err)
          Message({
            message: '上传失败',
            type: 'error',
            duration: 3 * 1000
          });
        })
      });
    },
    doDelCardResource(){
      const newArr = []
      for (let i=0;i<this.applyMerchant.imgs.length;i++){
        if (i === this.delImgIndex) continue
        newArr.push(this.applyMerchant.imgs[i])
      }
      this.applyMerchant.imgs=newArr
      this.showDelImg=false
    },
    onShowDelImg(i){
      this.delImgIndex = i
      this.showDelImg = true
    },
    moveResource(i,isUp){
      const newArr = JSON.parse(JSON.stringify(this.applyMerchant.imgs))
      const box = newArr[i]
      if (isUp){
        newArr[i]=newArr[i-1]
        newArr[i-1]=box
      }else{
        newArr[i]=newArr[i+1]
        newArr[i+1]=box
      }
      this.applyMerchant.imgs=newArr
    },
    uploadImg(){
      this.$refs.uploadImg.click()
    },
    onShowApplyMerchant(row){
      this.applyMerchant={
        wechatMpId:row.id,
        store:undefined,
        phone:undefined,
        nickname:undefined,
        areaDetailId:[],
        areaId:undefined,
        address:undefined,
        remark:undefined,
        state:undefined,
        reply:undefined,
        imgs:[],
      }
      getMerchantByWeChatMPId(row.id).then(res=>{
        const params = res.data
        if (params) {
          params.areaDetailId = params.areaDetailId.split(',').map(Number)
          params.imgs = params.urls.map(url=>this.fileBaseUrl+url)
          this.applyMerchant = params
        }
        this.showApplyMerchant=true
      })
    },
    search(){
      this.current=1
      this.size=10
      this.fetchData()
    },
    reset(){
      this.current=1
      this.size=10
      this.params = {}
      this.fetchData()
    },
    pageUsers(){
      page(this.current,this.size,this.params).then(res=>{
        this.records=res.data.data
        this.total=res.data.total
      })
    },
    getAreaDetails(){
      listAreas().then(res=>{
        let areaDetails = formatAgencyAreaDetails(res.data)
        this.areaDetails = areaDetails
      })
    },
    fetchData(){
      this.pageUsers()
    },
  },

  mounted() {
    this.getAreaDetails()
    this.fetchData()
  },

}
</script>

<style lang="scss" scoped>
.click {
  cursor: pointer;
  color: blue;
}
</style>